import Geometry from "./Geometry";
import Properties from "./Properties";
export default class Location {
  constructor({ geometry, id, properties, type } = {}) {
    this.geometry = new Geometry(geometry) || new Geometry();
    this.id = id || null;
    this.properties = new Properties(properties) || new Properties();
    this.type = type || "Feature";
  }
  getDataForCreateOrEditPost() {
    let properties = this.properties.getDataForCreateOrEditPost();
    properties.gemmici_id = this.id;
    return {
      type: this.type,
      properties,
      geometry: this.geometry.getDataForCreateOrEditPost()
    };
  }
}
